<template>
    <div class="d-none d-lg-block">
        <nav class="navbar navbar-expand-lg navbar-orange navbar-dark" id="main_menu">
            <a class="navbar-brand" href="#">
                <img src="images/bitacorapp-logo-white.png" class="shatter-logo-navbar" alt />
                <!-- <img src="images/shatter-logo-transp.png" class="shatter-logo-navbar" alt=""> -->
            </a>
            <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="showMenu">
                <ul class="navbar-nav mr-auto" v-if="showMenu">
                    <li v-for="(item, index) in menu" :key="index" class="nav-item">
                        <a
                            href="#"
                            class="nav-link menu-item"
                            @click.prevent="destination(item)"
                        >{{ item.name }}</a>
                    </li>
                </ul>

                <ul class="navbar-nav ml-auto">
                    <label v-if="enableNotifications" class="notification">
                        {{
                        totalNotifications
                        }}
                    </label>
                    <div v-if="enableNotifications">
                        <li class="nav-item dropdown mr-auto">
                            <a
                                class="nav-link menu-item dropdown-toggle"
                                href="#"
                                id="navbarDropdown"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i class="fa fa-bell"></i>
                            </a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <router-link
                                    class="dropdown-item"
                                    :to="{ name: 'assignedTasks' }"
                                >
                                    <i class="fa fa-thumb-tack" aria-hidden="true"></i>
                                    {{ tasks }} Tareas pendientes
                                </router-link>
                                <router-link
                                    class="dropdown-item"
                                    :to="{ name: 'myTasksList' }"
                                >
                                    <i class="fa fa-comment" aria-hidden="true"></i>
                                    {{ petitions }} Peticiones
                                    pendientes
                                </router-link>
                            </div>
                        </li>
                    </div>
                    <li class="nav-item dropdown mr-auto" v-if="!!alarms.length">
                        <a
                            class="nav-link menu-item dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i class="fa fa-bell" aria-hidden="true"></i>
                        </a>
                        <div
                            class="dropdown-menu"
                            aria-labelledby="navbarDropdown"
                            v-for="(alarm, index) in alarms"
                            :key="index"
                        >
                            <a class="dropdown-item" href="#" @click.prevent>
                                <i class="fa fa-sign-out" aria-hidden="true"></i>
                                {{ alarm.name }}
                            </a>
                        </div>
                    </li>
                    <li class="nav-item" v-if="!!client && !!user.profile.client_required">
                        <a href="#" class="nav-link menu-item">
                            <strong>Cliente:</strong>
                            {{ client.name }} ({{client.code}})
                        </a>
                    </li>
                    <li class="nav-item dropdown mr-auto">
                        <a
                            class="nav-link menu-item dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                            {{ user.name }}
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a
                                v-if="shiftActive"
                                class="dropdown-item"
                                href="#"
                                @click.prevent="
                                    $router.push({ name: 'shiftEndPage' })
                                "
                            >
                                <i class="fa fa-sign-out" aria-hidden="true"></i>
                                Entregar turno
                            </a>
                            <a
                                v-if="isAuthenticated"
                                class="dropdown-item"
                                href="#"
                                @click.prevent="accountPage"
                            >
                                <i class="fa fa-user" aria-hidden="true"></i>
                                Cuenta
                            </a>
                            <a class="dropdown-item" href="#" @click.prevent="logOut">
                                <i class="fa fa-sign-out" aria-hidden="true"></i>
                                Salir
                            </a>
                            <a class="dropdown-item" href="#" @click.prevent="updateSystem">
                                <i class="fa fa-refresh" aria-hidden="true"></i>
                                Actualizar
                            </a>
                        </div>
                    </li>
                    <li style="width:32px;">
                        <b-img src="images/topbar_preloader.gif" v-if="inProgress"></b-img>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    data: () => ({
        name: 'main-menu',
        enableNotifications: true,
        tasks: 0,
        petitions: 0,
        totalNotifications: 0,
    }),
    computed: {
        ...mapGetters(['alarms', 'menu', 'shift', 'menuOptions']),
        calcular() {
            return 'calculo'
        },
        showMenu() {
            if (this.user.profile.slug !== 'vigilante') return true

            return !!this.shift
        },
        shiftActive() {
            return !!this.shift && this.user.profile.slug === 'vigilante'
        },
    },
    methods: {
        ...mapActions(['logOut']),
        ...mapMutations(['setCurrentMenu']),

        async notifications() {
            if (this.user.profile.slug === 'administrativo') {
                this.enableNotifications = true
                const { data } = await repo.get(
                    `tasks/${this.user.id}/pending-tasks`
                )
                this.tasks = data.tasks
                this.petitions = data.petitions
                this.totalNotifications = this.tasks + this.petitions
            } else {
                this.enableNotifications = false
            }
        },
        destination(dest) {
            this.setCurrentMenu(dest)

            if (!this.menuOptions.length) return

            const firstOption = this.menuOptions.sort(
                (a, b) => a.order - b.order
            )[0]

            this.$router.push({
                name: firstOption.to,
            })
        },
        accountPage() {
            this.$router.push({
                name: 'accountPage',
            })
        },
        updateSystem() {
            window.location.reload(true)
        },
    },
    beforeMount() {
        this.notifications()
    },
    mounted() {
        this.$bus.$on('loadNotifications', this.notifications)
    },
}
</script>
<style>
.shatter-logo-navbar {
    height: 30px;
}
.notification {
    margin-right: -8px;
    font-weight: bold;
    color: white;
    font-size: 13px;
}
</style>
